import { useState } from "react";
import { useTranslation } from "react-i18next";
import { RevModal, RevButton } from "../ds";

const Modal = ({ title, message, showCancelButton, showConfirmButton, cancelButtonText, confirmButtonText, onCancel, onConfirm, loading, closable = true, inputConfirmation, confirmationPlaceholder, isDanger, customComponent, confirmDisabled = false }) => {
    const [inputConfirmationText, setInputConfirmationText] = useState('');
    const { t } = useTranslation();
    const hasBody = Boolean(message) || Boolean(customComponent) || inputConfirmation?.length > 1;
    const footer = (showCancelButton === true || showConfirmButton === true)
        ? <>
            {showCancelButton === true && <RevButton variant="secondary" onClick={onCancel}>{cancelButtonText}</RevButton>}
            {showConfirmButton === true
                && <RevButton
                    variant={isDanger ? 'danger' : 'primary'}
                    loading={loading}
                    disabled={confirmDisabled || (Boolean(inputConfirmation) && inputConfirmation !== inputConfirmationText)}
                    onClick={onConfirm}>{confirmButtonText}</RevButton>}
        </>
        : undefined;
    return (
        <RevModal
            width={520}
            title={title}
            closable={closable}
            onClose={onCancel}
            closeLabel={t('generic.alertButton.close')}
            footer={footer}
        >
            {hasBody &&
                <div className="rev-modal__body">
                    {message && <p>{message}</p>}
                    {customComponent
                        ? customComponent
                        : inputConfirmation?.length > 1 &&
                        <input
                            className="rev-input"
                            type="text"
                            placeholder={confirmationPlaceholder}
                            value={inputConfirmationText}
                            onChange={(e) => setInputConfirmationText(e.target.value)}
                            onKeyDown={(e) => { if (e.key === 'Enter') e.preventDefault(); }}
                        />
                    }
                </div>
            }
        </RevModal>
    );
}

export default Modal;
